var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"item-text":"displayName","item-value":"locationId","return-object":"","disabled":_vm.locked || !_vm.warehouseId,"clearable":_vm.clearable,"label":"Internal Location"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }